import { useMutation } from '@tanstack/react-query'

import { loginTwoFactorAuthSmsPost } from '@src/api'
import { DefaultApiLoginTwoFactorAuthSmsPostRequest } from '@src/api/generated/iam'
import { useAxios } from '@src/hooks/use-axios'

export const useLoginTwoFactorAuthSms = () => {
  const { axiosInstance } = useAxios({ apiType: 'IAM', shouldSkipLogout: true })

  return useMutation({
    mutationFn: (params: DefaultApiLoginTwoFactorAuthSmsPostRequest) =>
      loginTwoFactorAuthSmsPost(axiosInstance, params),
  })
}
